// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--Q5_f26dSDZs13dzv","image":"image--kHb1WzvV1HQFy4k8"};